// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"6729b4e2","506":"0df7f3ce","707":"490df2d7"}[chunkId] + ".js";
};